import { NavLink, useLocation } from 'react-router';
import { FileText, LayoutDashboard, Menu, Plus, Users } from 'lucide-react';
import { useSidebar } from '@/components/ui/sidebar';
import { useBusiness } from '@/lib/business';
import { cn } from '@/lib/utils';

/**
 * Phone navigation for the warm direction: the four places used daily, one clear "create" action in the middle
 * and a "More" button that opens the full menu. The active item is the only coral on the bar.
 */
export function MobileTabBar() {
  const { can } = useBusiness();
  const { pathname } = useLocation();
  const { setOpenMobile } = useSidebar();
  const tab = (to: string, label: string, Icon: typeof FileText, active: boolean) => (
    <NavLink
      key={to}
      to={to}
      aria-current={active ? 'page' : undefined}
      className={cn('flex min-h-14 flex-1 flex-col items-center justify-center gap-0.5 text-xs font-medium transition-colors', active ? 'text-primary-ink' : 'text-muted-foreground')}
    >
      <Icon className="size-5" aria-hidden strokeWidth={active ? 2.4 : 1.8} />
      {label}
    </NavLink>
  );
  return (
    <nav aria-label="Quick navigation" className="no-print fixed inset-x-0 bottom-0 z-30 flex items-stretch border-t bg-card/95 pb-[env(safe-area-inset-bottom)] shadow-[0_-4px_16px_-8px_rgb(60_40_20/0.18)] backdrop-blur md:hidden">
      {tab('/dashboard', 'Dashboard', LayoutDashboard, pathname === '/dashboard')}
      {tab('/invoices', 'Invoices', FileText, pathname === '/invoices')}
      {can('invoice:write') && (
        <NavLink to="/invoices/new" aria-label="New invoice" className="flex flex-1 items-center justify-center">
          <span className="flex size-11 items-center justify-center rounded-full bg-btn-primary text-btn-primary-fg shadow-md transition-transform active:scale-95">
            <Plus className="size-5" aria-hidden />
          </span>
        </NavLink>
      )}
      {can('customer:read') && tab('/customers', 'Customers', Users, false)}
      <button type="button" onClick={() => setOpenMobile(true)} className="flex min-h-14 flex-1 flex-col items-center justify-center gap-0.5 text-xs font-medium text-muted-foreground">
        <Menu className="size-5" aria-hidden strokeWidth={1.8} />
        More
      </button>
    </nav>
  );
}
